<div class="confirm-pop">
  <div class="confirm-head">
    <h2>{{ confirmTitle() }}</h2>
    @if (cancelType() === 'icon') {
    <button (click)="cancelClick()" class="arrow-btn"><img src="assets/images/close.svg" alt="" /></button>
    }
  </div>
  <div class="confirm-body">
    <p>{{ confirmMessage() }}</p>
  </div>
  <div class="confirm-footer">
    @if (cancelType() === 'button') {
    <button type="button" class="btn btn-cancel" (click)="cancelClick()">
      {{ cancelButtonText() }}
    </button>
    }
    <button type="button" class="btn {{ okClassName() }}" (click)="okClick()">
      {{ okButtonText() }}
    </button>
    @for (btn of secondaryButtons(); track btn) {
    <button type="button" class="btn {{ btn.class_name }}" (click)="secondarybuttonClick(btn)">{{ btn.name }}</button>
    }
  </div>
</div>
